import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Trash = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.3339 18.75V39.5831H16.667V18.75H33.3339ZM30.2089 6.25H19.792L17.7089 8.33313H10.417V12.5H39.5839V8.33313H32.292L30.2089 6.25ZM37.5001 14.5831H12.5001V39.5831C12.5033 40.6873 12.9433 41.7453 13.724 42.5261C14.5048 43.3069 15.5628 43.7469 16.667 43.75H33.3339C34.438 43.7469 35.4961 43.3069 36.2768 42.5261C37.0576 41.7453 37.4976 40.6873 37.5007 39.5831L37.5001 14.5831Z"
        fill={color}
      />
    </svg>
  )
}
